"use strict";
/*
 * Created on 20. 1. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var EcommerceAppConfig_1 = require("./EcommerceAppConfig");

var ManualSplitsAppConfig_1 = require("./ManualSplitsAppConfig");

var OpeningAppConfig_1 = require("./OpeningAppConfig");
/**
 * Configuration of promotion-related application subdomain. Note: AppConfig suffix is intended for configurations
 * exposed from backend to frontend application.
 *
 * @author Radek Beran
 * @author Tomas Leity
 */


var PromotionAppConfig =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromotionAppConfig, _DomainObject_1$Domai);

  /**
   * @param opening Config object of {@link OpeningAppConfig}
   * @param ecommerce Config object of {@link EcommerceAppConfig}
   * @param manualSplits Config object of {@link ManualSplitsAppConfig}
   */
  function PromotionAppConfig(opening, ecommerce, manualSplits) {
    var _this;

    _classCallCheck(this, PromotionAppConfig);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionAppConfig).call(this));
    _this.opening = opening;
    _this.ecommerce = ecommerce;
    _this.manualSplits = manualSplits;
    return _this;
  }

  return PromotionAppConfig;
}(DomainObject_1.DomainObject);

exports.PromotionAppConfig = PromotionAppConfig;

PromotionAppConfig.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromotionAppConfig.name);
  return {
    opening: builder.obj('opening', OpeningAppConfig_1.OpeningAppConfig.schema, function (mat) {
      return OpeningAppConfig_1.OpeningAppConfig.fromDataDict(mat);
    }),
    ecommerce: builder.obj('ecommerce', EcommerceAppConfig_1.EcommerceAppConfig.schema, function (mat) {
      return EcommerceAppConfig_1.EcommerceAppConfig.fromDataDict(mat);
    }),
    manualSplits: builder.obj('manualSplits', ManualSplitsAppConfig_1.ManualSplitsAppConfig.schema, function (mat) {
      return ManualSplitsAppConfig_1.ManualSplitsAppConfig.fromDataDict(mat);
    })
  };
}();